import React, { useState, useEffect } from 'react';
import { ShoppingCart, Plus, Minus, Sparkles, Droplets, Palette, Crown, Leaf, Activity, Wind, ChevronDown, ChevronUp, CreditCard, X, CheckCircle, AlertCircle, Lock, ExternalLink } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/iwv7yg1r_5de1b5a045590debeffab34f4c8179fd.jpg";

// Store sections with products - Detailed subcategories for Afro Hair Cosmetics
const storeCategories = [
  {
    id: 'afro_cosmetics',
    icon: Sparkles,
    title_en: 'Afro Hair Cosmetics',
    title_pt: 'Cosméticos Afro Hair',
    title_fr: 'Cosmétiques Afro Hair',
    title_de: 'Afro Hair Kosmetik',
    title_es: 'Cosméticos Afro Hair',
    hasSubcategories: true,
    subcategories: [
      {
        id: 'shampoos',
        title_en: 'Shampoos',
        title_pt: 'Shampoos',
        title_fr: 'Les Shampoings',
        title_de: 'Shampoos',
        title_es: 'Champús',
        products: [
          { id: 'sh1', name_en: 'Shea Moisture Coconut & Hibiscus Shampoo', name_pt: 'Shea Moisture Coconut & Hibiscus Shampoo', name_fr: 'Shea Moisture Coconut & Hibiscus Shampooing', price: 14.99, image: 'https://images.pexels.com/photos/11284698/pexels-photo-11284698.jpeg?w=400' },
          { id: 'sh2', name_en: 'Cantu Shea Butter Cleansing Shampoo', name_pt: 'Cantu Shea Butter Cleansing Shampoo', name_fr: 'Cantu Shea Butter Shampooing Nettoyant', price: 12.99, image: 'https://images.unsplash.com/photo-1673241073904-686d244b62e3?w=400' },
          { id: 'sh3', name_en: 'Mielle Rosemary Mint Shampoo', name_pt: 'Mielle Rosemary Mint Shampoo', name_fr: 'Mielle Rosemary Mint Shampooing', price: 13.99, image: 'https://images.pexels.com/photos/3735657/pexels-photo-3735657.jpeg?w=400' },
          { id: 'sh4', name_en: 'As I Am Curl Clarity Shampoo', name_pt: 'As I Am Curl Clarity Shampoo', name_fr: 'As I Am Curl Clarity Shampooing', price: 11.99, image: 'https://images.unsplash.com/photo-1766101293873-41ef9c5f32b5?w=400' },
        ]
      },
      {
        id: 'masks',
        title_en: 'Hair Masks',
        title_pt: 'Máscaras Capilares',
        title_fr: 'Les Masques Capillaires',
        title_de: 'Haarmasken',
        title_es: 'Mascarillas Capilares',
        products: [
          { id: 'mk1', name_en: 'Shea Moisture Manuka Honey Mask', name_pt: 'Shea Moisture Manuka Honey Mask', name_fr: 'Shea Moisture Masque Miel de Manuka', price: 16.99, image: 'https://images.pexels.com/photos/3809176/pexels-photo-3809176.jpeg?w=400' },
          { id: 'mk2', name_en: 'Cantu Deep Treatment Mask', name_pt: 'Cantu Deep Treatment Mask', name_fr: 'Cantu Masque Traitement Profond', price: 14.99, image: 'https://images.unsplash.com/photo-1672062519474-1a4407fdf387?w=400' },
          { id: 'mk3', name_en: 'Mielle Babassu Oil Conditioning Mask', name_pt: 'Mielle Babassu Oil Conditioning Mask', name_fr: 'Mielle Masque Conditionnant Huile de Babassu', price: 15.99, image: 'https://images.unsplash.com/photo-1762651356493-c492ca111a07?w=400' },
        ]
      },
      {
        id: 'conditioners',
        title_en: 'Conditioners',
        title_pt: 'Condicionadores',
        title_fr: 'Les Après-Shampoings',
        title_de: 'Conditioner',
        title_es: 'Acondicionadores',
        products: [
          { id: 'cd1', name_en: 'Shea Moisture Raw Shea Butter Conditioner', name_pt: 'Shea Moisture Raw Shea Butter Conditioner', name_fr: 'Shea Moisture Après-Shampooing Beurre de Karité', price: 13.99, image: 'https://images.unsplash.com/photo-1526947425960-945c6e72858f?w=400' },
          { id: 'cd2', name_en: 'Cantu Hydrating Cream Conditioner', name_pt: 'Cantu Hydrating Cream Conditioner', name_fr: 'Cantu Après-Shampooing Crème Hydratant', price: 11.99, image: 'https://images.unsplash.com/photo-1766101067640-b3ae41ba84bd?w=400' },
          { id: 'cd3', name_en: 'Mielle Pomegranate & Honey Conditioner', name_pt: 'Mielle Pomegranate & Honey Conditioner', name_fr: 'Mielle Après-Shampooing Grenade & Miel', price: 12.99, image: 'https://images.pexels.com/photos/9909784/pexels-photo-9909784.jpeg?w=400' },
        ]
      },
      {
        id: 'oils',
        title_en: 'Hair Oils',
        title_pt: 'Óleos Capilares',
        title_fr: 'Les Huiles Capillaires',
        title_de: 'Haaröle',
        title_es: 'Aceites Capilares',
        products: [
          { id: 'oi1', name_en: 'Mielle Rosemary Mint Scalp & Hair Oil', name_pt: 'Mielle Rosemary Mint Scalp & Hair Oil', name_fr: 'Mielle Huile Romarin & Menthe', price: 10.99, image: 'https://images.unsplash.com/photo-1672062519474-1a4407fdf387?w=400' },
          { id: 'oi2', name_en: 'Shea Moisture Jamaican Black Castor Oil', name_pt: 'Shea Moisture Jamaican Black Castor Oil', name_fr: 'Shea Moisture Huile de Ricin Noire Jamaïcaine', price: 12.99, image: 'https://images.pexels.com/photos/28994394/pexels-photo-28994394.jpeg?w=400' },
          { id: 'oi3', name_en: 'Cantu Tea Tree & Jojoba Oil', name_pt: 'Cantu Tea Tree & Jojoba Oil', name_fr: 'Cantu Huile Tea Tree & Jojoba', price: 9.99, image: 'https://images.pexels.com/photos/28994390/pexels-photo-28994390.jpeg?w=400' },
        ]
      },
      {
        id: 'creams',
        title_en: 'Styling Creams & Butters',
        title_pt: 'Cremes & Manteigas',
        title_fr: 'Les Crèmes & Beurres Coiffants',
        title_de: 'Stylingcremes & Butters',
        title_es: 'Cremas & Mantecas',
        products: [
          { id: 'cr1', name_en: 'Cantu Shea Butter Leave-In Cream', name_pt: 'Cantu Shea Butter Leave-In Cream', name_fr: 'Cantu Crème Sans Rinçage Beurre de Karité', price: 8.99, image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400' },
          { id: 'cr2', name_en: 'Shea Moisture Curl Enhancing Smoothie', name_pt: 'Shea Moisture Curl Enhancing Smoothie', name_fr: 'Shea Moisture Smoothie Définition Boucles', price: 14.99, image: 'https://images.unsplash.com/photo-1570194065650-d99fb4b38b15?w=400' },
          { id: 'cr3', name_en: 'Mielle Twisting Soufflé', name_pt: 'Mielle Twisting Soufflé', name_fr: 'Mielle Soufflé Torsades', price: 11.99, image: 'https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?w=400' },
        ]
      },
      {
        id: 'gels',
        title_en: 'Gels & Edge Controls',
        title_pt: 'Géis & Edge Controls',
        title_fr: 'Les Gels & Edge Controls',
        title_de: 'Gele & Edge Controls',
        title_es: 'Geles & Edge Controls',
        products: [
          { id: 'gl1', name_en: 'Eco Styler Olive Oil Gel', name_pt: 'Eco Styler Olive Oil Gel', name_fr: 'Eco Styler Gel Huile d\'Olive', price: 6.99, image: 'https://images.unsplash.com/photo-1535585209827-a15fcdbc4c2d?w=400' },
          { id: 'gl2', name_en: 'Cantu Extra Hold Edge Stay Gel', name_pt: 'Cantu Extra Hold Edge Stay Gel', name_fr: 'Cantu Gel Edge Control Extra Fort', price: 7.99, image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400' },
          { id: 'gl3', name_en: 'Mielle Honey & Ginger Edge Gel', name_pt: 'Mielle Honey & Ginger Edge Gel', name_fr: 'Mielle Gel Contours Miel & Gingembre', price: 8.99, image: 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=400' },
        ]
      },
      {
        id: 'sprays',
        title_en: 'Sprays & Mists',
        title_pt: 'Sprays & Névoas',
        title_fr: 'Les Sprays & Brumes',
        title_de: 'Sprays & Nebel',
        title_es: 'Sprays & Brumas',
        products: [
          { id: 'sp1', name_en: 'Shea Moisture Coconut & Hibiscus Mist', name_pt: 'Shea Moisture Coconut & Hibiscus Mist', name_fr: 'Shea Moisture Brume Coco & Hibiscus', price: 11.99, image: 'https://images.pexels.com/photos/17576512/pexels-photo-17576512.jpeg?w=400' },
          { id: 'sp2', name_en: 'Cantu Comeback Curl Spray', name_pt: 'Cantu Comeback Curl Spray', name_fr: 'Cantu Spray Ravive Boucles', price: 9.99, image: 'https://images.pexels.com/photos/13573917/pexels-photo-13573917.jpeg?w=400' },
        ]
      },
      {
        id: 'afterbraids',
        title_en: 'After Braids Kits',
        title_pt: 'Kits Pós-Tranças',
        title_fr: 'Kits Après Tresses',
        title_de: 'After Braids Kits',
        title_es: 'Kits Post-Trenzas',
        products: [
          { id: 'ab1', name_en: 'Complete After Braids Kit', name_pt: 'Kit After Braids Completo', name_fr: 'Kit Après Tresses Complet', price: 45.00, image: 'https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?w=400', description_en: 'Complete kit for post-braids hair care: moisturizing spray, scalp oil, leave-in conditioner, and edge control.', description_fr: 'Kit complet pour les soins capillaires après tresses : spray hydratant, huile pour cuir chevelu, après-shampooing sans rinçage et gel bordures.' },
          { id: 'ab2', name_en: 'Soothing Scalp Oil - After Braids', name_pt: 'Óleo Calmante Couro Cabeludo', name_fr: 'Huile Apaisante Cuir Chevelu', price: 18.00, image: 'https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?w=400', description_en: 'Calming oil to soothe itchy scalp after braids removal. With tea tree, peppermint, and jojoba oil.', description_fr: 'Huile apaisante pour calmer les démangeaisons du cuir chevelu après le retrait des tresses.' },
          { id: 'ab3', name_en: 'Detangling Moisturizing Spray - After Braids', name_pt: 'Spray Hidratante Detangle', name_fr: 'Spray Hydratant Démêlant', price: 15.00, image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400', description_en: 'Easy detangling spray to gently separate hair after braids. Adds moisture and reduces breakage.', description_fr: 'Spray démêlant facile pour séparer délicatement les cheveux après les tresses.' },
          { id: 'ab4', name_en: 'Protein Repair Mask - After Braids', name_pt: 'Máscara Proteína Reparadora', name_fr: 'Masque Réparateur Protéiné', price: 28.00, image: 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=400', description_en: 'Deep conditioning protein mask to restore strength and elasticity to hair stressed by braids.', description_fr: 'Masque protéiné revitalisant en profondeur pour restaurer la force et l\'élasticité des cheveux.' },
        ]
      }
    ],
    products: [] // Empty as we use subcategories
  },
  {
    id: 'skincare',
    icon: Droplets,
    title_en: 'Skincare Products',
    title_pt: 'Produtos Skincare',
    title_fr: 'Produits Skincare',
    title_de: 'Hautpflegeprodukte',
    title_es: 'Productos Skincare',
    products: [
      { id: 'sk1', name_en: 'Bio Facial Cream', name_pt: 'Creme Facial Bio', name_fr: 'Crème Visage Bio', price: 35.00, image: 'https://images.unsplash.com/photo-1570194065650-d99fb4b38b15?w=400' },
      { id: 'sk2', name_en: 'Vitamin C Serum', name_pt: 'Sérum Vitamina C', name_fr: 'Sérum Vitamine C', price: 42.00, image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400' },
      { id: 'sk3', name_en: 'Organic Face Mask', name_pt: 'Máscara Facial Orgânica', name_fr: 'Masque Visage Bio', price: 28.00, image: 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=400' },
      { id: 'sk4', name_en: 'Anti-Aging Cream', name_pt: 'Creme Anti-Idade', name_fr: 'Crème Anti-Âge', price: 48.00, image: 'https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?w=400' },
    ]
  },
  {
    id: 'body_products',
    icon: Sparkles,
    title_en: 'Body Products',
    title_pt: 'Produtos Corporais',
    title_fr: 'Produits Corporels',
    title_de: 'Körperprodukte',
    title_es: 'Productos Corporales',
    products: [
      { id: 'bp1', name_en: 'Body Lotion', name_pt: 'Loção Corporal', name_fr: 'Lotion Corporelle', price: 24.00, image: 'https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?w=400' },
      { id: 'bp2', name_en: 'Body Scrub', name_pt: 'Esfoliante Corporal', name_fr: 'Gommage Corporel', price: 28.00, image: 'https://images.unsplash.com/photo-1570194065650-d99fb4b38b15?w=400' },
      { id: 'bp3', name_en: 'Body Oil', name_pt: 'Óleo Corporal', name_fr: 'Huile Corporelle', price: 32.00, image: 'https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?w=400' },
      { id: 'bp4', name_en: 'Body Butter', name_pt: 'Manteiga Corporal', name_fr: 'Beurre Corporel', price: 26.00, image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400' },
    ]
  },
  {
    id: 'makeup',
    icon: Palette,
    title_en: 'Makeup Products',
    title_pt: 'Produtos de Maquilhagem',
    title_fr: 'Produits de Maquillage',
    title_de: 'Make-up Produkte',
    title_es: 'Productos de Maquillaje',
    products: [
      { id: 'mk1', name_en: 'Foundation Set', name_pt: 'Kit de Base', name_fr: 'Kit Fond de Teint', price: 45.00, image: 'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=400' },
      { id: 'mk2', name_en: 'Lipstick Collection', name_pt: 'Coleção de Batons', name_fr: 'Collection Rouges à Lèvres', price: 32.00, image: 'https://images.unsplash.com/photo-1586495777744-4413f21062fa?w=400' },
      { id: 'mk3', name_en: 'Eye Shadow Palette', name_pt: 'Paleta de Sombras', name_fr: 'Palette Ombres à Paupières', price: 38.00, image: 'https://images.unsplash.com/photo-1583241800698-e8ab01d85b24?w=400' },
    ]
  },
  {
    id: 'hair_accessories',
    icon: Crown,
    title_en: 'Hair Accessories',
    title_pt: 'Acessórios para Cabelo',
    title_fr: 'Accessoires Cheveux',
    title_de: 'Haarschmuck',
    title_es: 'Accesorios para el Cabello',
    products: [
      { id: 'ha1', name_en: 'Afro Comb Kit', name_pt: 'Kit Pentes Afro', name_fr: 'Kit Peignes Afro', price: 15.00, image: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400' },
      { id: 'ha2', name_en: 'Silk Scarves', name_pt: 'Lenços de Seda', name_fr: 'Foulards en Soie', price: 25.00, image: 'https://images.unsplash.com/photo-1601612628452-9e99ced43524?w=400' },
      { id: 'ha3', name_en: 'Hair Clips Set', name_pt: 'Conjunto de Ganchos', name_fr: 'Set Pinces à Cheveux', price: 12.00, image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400' },
      { id: 'ha4', name_en: 'Satin Bonnet', name_pt: 'Touca de Cetim', name_fr: 'Bonnet en Satin', price: 18.00, image: 'https://images.unsplash.com/photo-1590439471364-192aa70c0b53?w=400' },
    ]
  },
  {
    id: 'slimming_tea',
    icon: Leaf,
    title_en: 'Slimming Detox Tea',
    title_pt: 'Chás Detox Emagrecedor',
    title_fr: 'Thé Détox Minceur',
    title_de: 'Detox Schlankheitstee',
    title_es: 'Té Detox Adelgazante',
    products: [
      { id: 'st1', name_en: 'Slimming Detox Tea', name_pt: 'Chá Detox Emagrecedor', name_fr: 'Thé Détox Minceur', price: 22.00, image: 'https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=400' },
      { id: 'st2', name_en: 'Relaxing Tea', name_pt: 'Chá Relaxante', name_fr: 'Thé Relaxant', price: 18.00, image: 'https://images.unsplash.com/photo-1597318181409-cf64d0b5d8a2?w=400' },
      { id: 'st3', name_en: 'Green Tea Blend', name_pt: 'Mistura de Chá Verde', name_fr: 'Mélange Thé Vert', price: 20.00, image: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=400' },
    ]
  },
  {
    id: 'slimming_accessories',
    icon: Activity,
    title_en: 'Slimming Accessories',
    title_pt: 'Acessórios Emagrecimento',
    title_fr: 'Accessoires Minceur',
    title_de: 'Schlankheitszubehör',
    title_es: 'Accesorios Adelgazantes',
    products: [
      { id: 'sa1', name_en: 'Body Wrap Kit', name_pt: 'Kit Body Wrap', name_fr: 'Kit Body Wrap', price: 35.00, image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=400' },
      { id: 'sa2', name_en: 'Massage Roller', name_pt: 'Rolo de Massagem', name_fr: 'Rouleau de Massage', price: 28.00, image: 'https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=400' },
      { id: 'sa3', name_en: 'Cupping Set', name_pt: 'Kit de Ventosas', name_fr: 'Kit Ventouses', price: 32.00, image: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=400' },
    ]
  },
  {
    id: 'extensions_wigs',
    icon: Wind,
    title_en: 'Extensions & Wigs',
    title_pt: 'Extensões e Perucas',
    title_fr: 'Extensions et Perruques',
    title_de: 'Extensions und Perücken',
    title_es: 'Extensiones y Pelucas',
    products: [
      { id: 'ew1', name_en: 'Brazilian Hair Extensions', name_pt: 'Extensões Cabelo Brasileiro', name_fr: 'Extensions Cheveux Brésiliens', price: 85.00, image: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400' },
      { id: 'ew2', name_en: 'Lace Front Wig', name_pt: 'Peruca Lace Front', name_fr: 'Perruque Lace Front', price: 120.00, image: 'https://images.unsplash.com/photo-1595959183082-7b570b7e1dfa?w=400' },
      { id: 'ew3', name_en: 'Crochet Braids Pack', name_pt: 'Pack Tranças Crochet', name_fr: 'Pack Tresses Crochet', price: 45.00, image: 'https://images.unsplash.com/photo-1529068755536-a5ade0dcb4e8?w=400' },
      { id: 'ew4', name_en: 'Clip-in Extensions', name_pt: 'Extensões Clip-in', name_fr: 'Extensions à Clips', price: 65.00, image: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400' },
    ]
  },
];

const REVOLUT_LINK = "https://revolut.me/estheri5im";

const StorePage = () => {
  const { language, t } = useLanguage();
  const [cart, setCart] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({ afro_cosmetics: true });
  const [showCheckout, setShowCheckout] = useState(false);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({ name: '', email: '' });
  const [paymentStatus, setPaymentStatus] = useState(null);

  // Check for payment status from URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment = params.get('payment');
    const sessionId = params.get('session_id');
    
    if (payment === 'success' && sessionId) {
      setPaymentStatus('success');
      setCart([]);
      // Clean URL
      window.history.replaceState({}, '', '/store');
    } else if (payment === 'cancelled') {
      setPaymentStatus('cancelled');
      window.history.replaceState({}, '', '/store');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTitle = (item) => {
    switch(language) {
      case 'fr': return item.title_fr || item.name_fr || item.title_en || item.name_en;
      case 'de': return item.title_de || item.name_de || item.title_en || item.name_en;
      case 'pt': return item.title_pt || item.name_pt || item.title_en || item.name_en;
      case 'es': return item.title_es || item.name_es || item.title_en || item.name_en;
      default: return item.title_en || item.name_en;
    }
  };

  const toggleCategory = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const addToCart = (product) => {
    setCart(prev => {
      const existing = prev.find(item => item.id === product.id);
      if (existing) {
        return prev.map(item => 
          item.id === product.id 
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
  };

  const removeFromCart = (productId) => {
    setCart(prev => {
      const existing = prev.find(item => item.id === productId);
      if (existing && existing.quantity > 1) {
        return prev.map(item =>
          item.id === productId
            ? { ...item, quantity: item.quantity - 1 }
            : item
        );
      }
      return prev.filter(item => item.id !== productId);
    });
  };

  const cartTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  // Checkout translations
  const checkoutText = {
    en: {
      checkout: 'Checkout',
      securePayment: 'Secure Payment',
      yourDetails: 'Your Details',
      name: 'Full Name',
      email: 'Email Address',
      orderSummary: 'Order Summary',
      total: 'Total',
      payNow: 'Pay via Revolut',
      processing: 'Processing...',
      paymentMethods: 'We accept',
      successTitle: 'Redirecting to Payment!',
      successMsg: 'You will be redirected to Revolut to complete your payment. After payment, please send your order confirmation via WhatsApp or email.',
      cancelledTitle: 'Payment Cancelled',
      cancelledMsg: 'Your payment was cancelled. Your cart items are still available.',
      close: 'Close',
      continueShopping: 'Continue Shopping',
      secureNote: 'Your payment is secured via Revolut'
    },
    fr: {
      checkout: 'Paiement',
      securePayment: 'Paiement Sécurisé',
      yourDetails: 'Vos Coordonnées',
      name: 'Nom Complet',
      email: 'Adresse Email',
      orderSummary: 'Récapitulatif',
      total: 'Total',
      payNow: 'Payer via Revolut',
      processing: 'Traitement...',
      paymentMethods: 'Nous acceptons',
      successTitle: 'Redirection vers le Paiement !',
      successMsg: 'Vous serez redirigé vers Revolut pour finaliser votre paiement. Après le paiement, envoyez-nous votre confirmation de commande par WhatsApp ou email.',
      cancelledTitle: 'Paiement Annulé',
      cancelledMsg: 'Votre paiement a été annulé. Vos articles sont toujours dans le panier.',
      close: 'Fermer',
      continueShopping: 'Continuer les Achats',
      secureNote: 'Votre paiement est sécurisé via Revolut'
    },
    pt: {
      checkout: 'Pagamento',
      securePayment: 'Pagamento Seguro',
      yourDetails: 'Os Seus Dados',
      name: 'Nome Completo',
      email: 'Endereço de Email',
      orderSummary: 'Resumo do Pedido',
      total: 'Total',
      payNow: 'Pagar via Revolut',
      processing: 'Processando...',
      paymentMethods: 'Aceitamos',
      successTitle: 'Redirecionando para Pagamento!',
      successMsg: 'Será redirecionado para o Revolut para completar o pagamento. Após o pagamento, envie a confirmação da encomenda por WhatsApp ou email.',
      cancelledTitle: 'Pagamento Cancelado',
      cancelledMsg: 'O seu pagamento foi cancelado. Os artigos ainda estão no carrinho.',
      close: 'Fechar',
      continueShopping: 'Continuar a Comprar',
      secureNote: 'O seu pagamento é protegido via Revolut'
    },
    de: {
      checkout: 'Kasse',
      securePayment: 'Sichere Zahlung',
      yourDetails: 'Ihre Daten',
      name: 'Vollständiger Name',
      email: 'E-Mail-Adresse',
      orderSummary: 'Bestellübersicht',
      total: 'Gesamt',
      payNow: 'Zahlen via Revolut',
      processing: 'Verarbeitung...',
      paymentMethods: 'Wir akzeptieren',
      successTitle: 'Weiterleitung zur Zahlung!',
      successMsg: 'Sie werden zu Revolut weitergeleitet. Nach der Zahlung senden Sie uns bitte Ihre Bestellbestätigung per WhatsApp oder E-Mail.',
      cancelledTitle: 'Zahlung Abgebrochen',
      cancelledMsg: 'Ihre Zahlung wurde abgebrochen. Ihre Artikel sind noch im Warenkorb.',
      close: 'Schließen',
      continueShopping: 'Weiter Einkaufen',
      secureNote: 'Ihre Zahlung ist gesichert via Revolut'
    },
    es: {
      checkout: 'Pago',
      securePayment: 'Pago Seguro',
      yourDetails: 'Sus Datos',
      name: 'Nombre Completo',
      email: 'Correo Electrónico',
      orderSummary: 'Resumen del Pedido',
      total: 'Total',
      payNow: 'Pagar via Revolut',
      processing: 'Procesando...',
      paymentMethods: 'Aceptamos',
      successTitle: '¡Redirigiendo al Pago!',
      successMsg: 'Será redirigido a Revolut para completar el pago. Después del pago, envíenos la confirmación de su pedido por WhatsApp o email.',
      cancelledTitle: 'Pago Cancelado',
      cancelledMsg: 'Su pago fue cancelado. Sus artículos siguen en el carrito.',
      close: 'Cerrar',
      continueShopping: 'Seguir Comprando',
      secureNote: 'Su pago está protegido via Revolut'
    }
  };
  const ct = checkoutText[language] || checkoutText.en;

  const handleCheckout = async () => {
    if (!customerInfo.name || !customerInfo.email) {
      return;
    }
    
    setCheckoutLoading(true);
    
    // Build Revolut payment URL with total amount
    const revolutUrl = `${REVOLUT_LINK}?amount=${Math.round(cartTotal)}&currency=EUR`;
    
    // Open Revolut payment in new tab
    window.open(revolutUrl, '_blank');
    
    // Show success message and clear cart
    setPaymentStatus('success');
    setCart([]);
    setShowCheckout(false);
    setCheckoutLoading(false);
  };

  return (
    <div className="min-h-screen bg-kamit-beige pt-20" data-testid="store-page">
      {/* Hero with Image */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src={HERO_IMAGE}
            alt="Store"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-kamit-dark/60 via-kamit-dark/40 to-kamit-dark/70" />
        </div>
        <div className="relative z-10 text-center px-4">
          <h1 className="font-heading text-5xl md:text-6xl text-kamit-beige mb-4">
            {t('store_title')}
          </h1>
          <p className="text-kamit-beige/80 text-lg max-w-2xl mx-auto">
            {language === 'fr'
              ? 'Produits de beauté biologiques et accessoires'
              : language === 'de'
              ? 'Bio-Schönheitsprodukte und Zubehör'
              : language === 'pt'
              ? 'Produtos de beleza orgânicos e acessórios'
              : language === 'es'
              ? 'Productos de belleza orgánicos y accesorios'
              : 'Organic beauty products and accessories'
            }
          </p>
        </div>
      </section>

      {/* Cart Badge */}
      {cartCount > 0 && (
        <div className="fixed bottom-8 right-8 z-50">
          <Button 
            onClick={() => setShowCheckout(true)}
            className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-6 py-6 shadow-lg"
            data-testid="cart-button"
          >
            <ShoppingCart className="h-5 w-5 mr-2" />
            {cartCount} {language === 'fr' ? 'articles' : language === 'pt' ? 'itens' : 'items'} - €{cartTotal.toFixed(2)}
            <CreditCard className="h-5 w-5 ml-2" />
          </Button>
        </div>
      )}

      {/* Category Sections */}
      {storeCategories.map((category, index) => {
        const IconComponent = category.icon;
        const isEven = index % 2 === 0;
        const isExpanded = expandedCategories[category.id];
        
        return (
          <section 
            key={category.id}
            className={`py-16 ${isEven ? 'bg-white' : 'bg-kamit-cream'}`}
            data-testid={`section-${category.id}`}
          >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              {/* Section Header */}
              <div 
                className={`flex items-center gap-3 mb-8 ${category.hasSubcategories ? 'cursor-pointer' : ''}`}
                onClick={() => category.hasSubcategories && toggleCategory(category.id)}
              >
                <div className="w-12 h-12 bg-kamit-gold/20 rounded-full flex items-center justify-center">
                  <IconComponent className="h-6 w-6 text-kamit-gold" />
                </div>
                <h2 className="font-heading text-2xl md:text-3xl text-kamit-brown">
                  {getTitle(category)}
                </h2>
                <div className="flex-1 h-px bg-kamit-brown/20 ml-4" />
                {category.hasSubcategories && (
                  <button className="p-2 rounded-full hover:bg-kamit-brown/10 text-kamit-brown transition-colors">
                    {isExpanded ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
                  </button>
                )}
              </div>

              {/* Subcategories for Afro Cosmetics */}
              {category.hasSubcategories && isExpanded && category.subcategories && (
                <div className="space-y-12">
                  {category.subcategories.map((subcategory) => (
                    <div key={subcategory.id} className="bg-kamit-beige/30 rounded-2xl p-6" data-testid={`subcategory-${subcategory.id}`}>
                      <h3 className="font-heading text-xl text-kamit-brown mb-6 flex items-center gap-2">
                        <span className="w-2 h-2 bg-kamit-gold rounded-full"></span>
                        {getTitle(subcategory)}
                      </h3>
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {subcategory.products.map((product) => {
                          const cartItem = cart.find(item => item.id === product.id);
                          return (
                            <div
                              key={product.id}
                              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow group border border-kamit-brown/5"
                              data-testid={`product-${product.id}`}
                            >
                              <div className="relative aspect-square overflow-hidden">
                                <img
                                  src={product.image}
                                  alt={getTitle(product)}
                                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                />
                              </div>
                              <div className="p-4">
                                <h4 className="font-medium text-kamit-brown mb-2 text-sm line-clamp-2 min-h-[2.5rem]">
                                  {getTitle(product)}
                                </h4>
                                <p className="text-kamit-gold font-semibold text-lg mb-3">
                                  €{product.price.toFixed(2)}
                                </p>
                                
                                {cartItem ? (
                                  <div className="flex items-center justify-between bg-kamit-cream rounded-full p-1">
                                    <button
                                      onClick={() => removeFromCart(product.id)}
                                      className="p-2 rounded-full hover:bg-kamit-brown/10 text-kamit-brown"
                                      data-testid={`remove-${product.id}`}
                                    >
                                      <Minus className="h-4 w-4" />
                                    </button>
                                    <span className="font-medium text-kamit-brown">
                                      {cartItem.quantity}
                                    </span>
                                    <button
                                      onClick={() => addToCart(product)}
                                      className="p-2 rounded-full hover:bg-kamit-brown/10 text-kamit-brown"
                                      data-testid={`add-${product.id}`}
                                    >
                                      <Plus className="h-4 w-4" />
                                    </button>
                                  </div>
                                ) : (
                                  <Button
                                    onClick={() => addToCart(product)}
                                    className="w-full bg-kamit-brown hover:bg-kamit-dark text-kamit-beige rounded-full text-sm"
                                    data-testid={`add-to-cart-${product.id}`}
                                  >
                                    {language === 'fr' ? 'Ajouter' : language === 'pt' ? 'Adicionar' : language === 'de' ? 'Hinzufügen' : language === 'es' ? 'Añadir' : 'Add to Cart'}
                                  </Button>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Regular Products Grid (for categories without subcategories) */}
              {!category.hasSubcategories && category.products && category.products.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                  {category.products.map((product) => {
                    const cartItem = cart.find(item => item.id === product.id);
                    return (
                      <div
                        key={product.id}
                        className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow group border border-kamit-brown/5"
                        data-testid={`product-${product.id}`}
                      >
                        <div className="relative aspect-square overflow-hidden">
                          <img
                            src={product.image}
                            alt={getTitle(product)}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                          />
                        </div>
                        <div className="p-4">
                          <h3 className="font-medium text-kamit-brown mb-2 text-sm">
                            {getTitle(product)}
                          </h3>
                          <p className="text-kamit-gold font-semibold text-lg mb-3">
                            €{product.price.toFixed(2)}
                          </p>
                          
                          {cartItem ? (
                            <div className="flex items-center justify-between bg-kamit-cream rounded-full p-1">
                              <button
                                onClick={() => removeFromCart(product.id)}
                                className="p-2 rounded-full hover:bg-kamit-brown/10 text-kamit-brown"
                                data-testid={`remove-${product.id}`}
                              >
                                <Minus className="h-4 w-4" />
                              </button>
                              <span className="font-medium text-kamit-brown">
                                {cartItem.quantity}
                              </span>
                              <button
                                onClick={() => addToCart(product)}
                                className="p-2 rounded-full hover:bg-kamit-brown/10 text-kamit-brown"
                                data-testid={`add-${product.id}`}
                              >
                                <Plus className="h-4 w-4" />
                              </button>
                            </div>
                          ) : (
                            <Button
                              onClick={() => addToCart(product)}
                              className="w-full bg-kamit-brown hover:bg-kamit-dark text-kamit-beige rounded-full text-sm"
                              data-testid={`add-to-cart-${product.id}`}
                            >
                              {language === 'fr' ? 'Ajouter' : language === 'pt' ? 'Adicionar' : language === 'de' ? 'Hinzufügen' : language === 'es' ? 'Añadir' : 'Add to Cart'}
                            </Button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </section>
        );
      })}

      {/* Info & Payment */}
      <section className="py-16 bg-kamit-brown">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl text-kamit-beige mb-4">
            {language === 'fr' ? 'Produits Bio & Organiques' : language === 'de' ? 'Bio & Organische Produkte' : language === 'pt' ? 'Produtos Bio & Orgânicos' : language === 'es' ? 'Productos Bio & Orgánicos' : 'Bio & Organic Products'}
          </h2>
          <p className="text-kamit-beige/70 mb-8">
            {language === 'fr'
              ? 'Tous nos produits sont sélectionnés pour leur qualité et leur engagement envers des ingrédients naturels et durables.'
              : language === 'de'
              ? 'Alle unsere Produkte werden nach Qualität und Engagement für natürliche und nachhaltige Inhaltsstoffe ausgewählt.'
              : language === 'pt'
              ? 'Todos os nossos produtos são selecionados pela qualidade e compromisso com ingredientes naturais e sustentáveis.'
              : language === 'es'
              ? 'Todos nuestros productos son seleccionados por su calidad y compromiso con ingredientes naturales y sostenibles.'
              : 'All our products are selected for quality and commitment to natural and sustainable ingredients.'
            }
          </p>
          
          {/* Payment Methods */}
          <div className="bg-kamit-dark/30 backdrop-blur-sm rounded-2xl p-8 mb-8">
            <h3 className="font-heading text-2xl text-kamit-beige mb-6">
              {language === 'fr' ? 'Moyens de Paiement' : language === 'de' ? 'Zahlungsmethoden' : language === 'pt' ? 'Métodos de Pagamento' : language === 'es' ? 'Métodos de Pago' : 'Payment Methods'}
            </h3>
            <p className="text-kamit-beige/70 text-sm mb-6">
              {language === 'fr'
                ? 'Effectuez votre paiement de manière sécurisée via nos plateformes partenaires'
                : language === 'de'
                ? 'Führen Sie Ihre Zahlung sicher über unsere Partnerplattformen durch'
                : language === 'pt'
                ? 'Efetue o seu pagamento de forma segura através das nossas plataformas parceiras'
                : language === 'es'
                ? 'Realice su pago de forma segura a través de nuestras plataformas asociadas'
                : 'Make your payment securely through our partner platforms'
              }
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://revolut.me/estheri5im" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 bg-[#0075EB] hover:bg-[#0066CC] text-white rounded-full px-8 py-4 font-medium transition-colors"
              >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.9 6.5c-.2-.7-.6-1.3-1.2-1.7-.6-.4-1.3-.6-2-.6H6.4c-.7 0-1.4.2-2 .6-.6.4-1 1-1.2 1.7L2 12l1.2 5.5c.2.7.6 1.3 1.2 1.7.6.4 1.3.6 2 .6h11.3c.7 0 1.4-.2 2-.6.6-.4 1-1 1.2-1.7L22 12l-1.1-5.5zM12 16c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"/>
                </svg>
                Revolut
              </a>
              <a 
                href="https://www.paypal.me/estherceline" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 bg-[#003087] hover:bg-[#001F5C] text-white rounded-full px-8 py-4 font-medium transition-colors"
              >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 3.72a.77.77 0 0 1 .757-.629h6.724c2.205 0 3.746.52 4.578 1.543.378.464.62.978.726 1.531.107.565.107 1.236-.004 2.008l-.012.076v.664l.518.298a3.47 3.47 0 0 1 1.046.849c.323.392.549.865.67 1.403.126.552.148 1.21.063 1.952-.097.86-.303 1.607-.611 2.221a4.59 4.59 0 0 1-1.177 1.512 4.66 4.66 0 0 1-1.66.912c-.629.205-1.352.308-2.147.308H12.96a.93.93 0 0 0-.92.768l-.044.256-.7 4.437-.034.178a.93.93 0 0 1-.92.768H7.076z"/>
                </svg>
                PayPal
              </a>
            </div>
          </div>
          
          <p className="text-kamit-beige/50 text-sm mb-6">
            {language === 'fr'
              ? 'Après votre paiement, envoyez-nous une confirmation par WhatsApp ou email avec votre commande.'
              : language === 'de'
              ? 'Nach Ihrer Zahlung senden Sie uns bitte eine Bestätigung per WhatsApp oder E-Mail mit Ihrer Bestellung.'
              : language === 'pt'
              ? 'Após o pagamento, envie-nos uma confirmação por WhatsApp ou email com a sua encomenda.'
              : language === 'es'
              ? 'Después de su pago, envíenos una confirmación por WhatsApp o email con su pedido.'
              : 'After your payment, send us a confirmation via WhatsApp or email with your order.'
            }
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="https://wa.me/351935984047" target="_blank" rel="noopener noreferrer">
              <Button className="bg-kamit-green hover:bg-kamit-green/90 text-white rounded-full px-8">
                WhatsApp
              </Button>
            </a>
            <a href="mailto:lprbckamit@gmail.com">
              <Button variant="outline" className="border-2 border-kamit-beige text-kamit-beige hover:bg-kamit-beige hover:text-kamit-dark rounded-full px-8">
                Email
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Checkout Modal */}
      {showCheckout && cart.length > 0 && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setShowCheckout(false)}
        >
          <div 
            className="bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div className="sticky top-0 bg-kamit-brown p-6 rounded-t-2xl z-10">
              <button 
                onClick={() => setShowCheckout(false)}
                className="absolute top-4 right-4 text-kamit-beige/80 hover:text-kamit-beige"
              >
                <X className="h-6 w-6" />
              </button>
              <div className="flex items-center gap-3">
                <div className="p-2 bg-kamit-gold/20 rounded-full">
                  <Lock className="h-6 w-6 text-kamit-gold" />
                </div>
                <div>
                  <h3 className="font-heading text-xl text-kamit-beige">
                    {ct.securePayment}
                  </h3>
                  <p className="text-kamit-beige/60 text-xs">{ct.secureNote}</p>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-6 space-y-6">
              {/* Customer Details */}
              <div>
                <h4 className="font-medium text-kamit-brown mb-4 flex items-center gap-2">
                  <CreditCard className="h-5 w-5 text-kamit-gold" />
                  {ct.yourDetails}
                </h4>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm text-kamit-brown/70 mb-1">{ct.name} *</label>
                    <input
                      type="text"
                      value={customerInfo.name}
                      onChange={(e) => setCustomerInfo(prev => ({ ...prev, name: e.target.value }))}
                      className="w-full p-3 border border-kamit-brown/20 rounded-xl focus:ring-2 focus:ring-kamit-gold focus:border-transparent"
                      placeholder="John Doe"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-kamit-brown/70 mb-1">{ct.email} *</label>
                    <input
                      type="email"
                      value={customerInfo.email}
                      onChange={(e) => setCustomerInfo(prev => ({ ...prev, email: e.target.value }))}
                      className="w-full p-3 border border-kamit-brown/20 rounded-xl focus:ring-2 focus:ring-kamit-gold focus:border-transparent"
                      placeholder="john@example.com"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Order Summary */}
              <div className="bg-kamit-beige/30 rounded-xl p-4">
                <h4 className="font-medium text-kamit-brown mb-3">{ct.orderSummary}</h4>
                <div className="space-y-2 max-h-40 overflow-y-auto">
                  {cart.map(item => (
                    <div key={item.id} className="flex justify-between text-sm">
                      <span className="text-kamit-brown/70">
                        {getTitle(item)} x{item.quantity}
                      </span>
                      <span className="text-kamit-brown font-medium">
                        €{(item.price * item.quantity).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="border-t border-kamit-brown/10 mt-3 pt-3 flex justify-between">
                  <span className="font-medium text-kamit-brown">{ct.total}</span>
                  <span className="font-bold text-kamit-gold text-lg">€{cartTotal.toFixed(2)}</span>
                </div>
              </div>

              {/* Payment Methods Icons */}
              <div className="text-center">
                <p className="text-sm text-kamit-brown/60 mb-3">{ct.paymentMethods}</p>
                <div className="flex justify-center items-center gap-3 flex-wrap">
                  <div className="bg-black text-white px-2 py-1 rounded text-xs font-semibold">Revolut</div>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/100px-Visa_Inc._logo.svg.png" alt="Visa" className="h-5 object-contain" />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/100px-Mastercard-logo.svg.png" alt="Mastercard" className="h-7 object-contain" />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/100px-PayPal.svg.png" alt="PayPal" className="h-5 object-contain" />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Google_Pay_Logo.svg/100px-Google_Pay_Logo.svg.png" alt="Google Pay" className="h-5 object-contain" />
                </div>
              </div>

              {/* Pay Button */}
              <Button
                onClick={handleCheckout}
                disabled={checkoutLoading || !customerInfo.name || !customerInfo.email}
                className="w-full bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full py-6 text-lg disabled:opacity-50"
              >
                {checkoutLoading ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin h-5 w-5 mr-2" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    {ct.processing}
                  </span>
                ) : (
                  <>
                    <ExternalLink className="mr-2 h-5 w-5" />
                    {ct.payNow} - €{cartTotal.toFixed(2)}
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Payment Success Modal */}
      {paymentStatus === 'success' && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setPaymentStatus(null)}
        >
          <div 
            className="bg-white rounded-2xl max-w-md w-full shadow-2xl p-8 text-center"
            onClick={e => e.stopPropagation()}
          >
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="h-10 w-10 text-green-600" />
            </div>
            <h3 className="font-heading text-2xl text-kamit-brown mb-2">
              {ct.successTitle}
            </h3>
            <p className="text-kamit-brown/70 mb-6">
              {ct.successMsg}
            </p>
            <Button
              onClick={() => setPaymentStatus(null)}
              className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-8"
            >
              {ct.continueShopping}
            </Button>
          </div>
        </div>
      )}

      {/* Payment Cancelled Modal */}
      {paymentStatus === 'cancelled' && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setPaymentStatus(null)}
        >
          <div 
            className="bg-white rounded-2xl max-w-md w-full shadow-2xl p-8 text-center"
            onClick={e => e.stopPropagation()}
          >
            <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <AlertCircle className="h-10 w-10 text-yellow-600" />
            </div>
            <h3 className="font-heading text-2xl text-kamit-brown mb-2">
              {ct.cancelledTitle}
            </h3>
            <p className="text-kamit-brown/70 mb-6">
              {ct.cancelledMsg}
            </p>
            <Button
              onClick={() => setPaymentStatus(null)}
              className="bg-kamit-brown hover:bg-kamit-dark text-kamit-beige rounded-full px-8"
            >
              {ct.close}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StorePage;
